import { IAffiliationData } from "src/app/shared/interfaces/AffiliationData.type";

export const affiliationData: IAffiliationData = {
    'physicians': [
        "Hospital",
        "Clinic",
        "Concierge Practice",
        "Independent"
    ],
    'ecosystem': [
        "Hospital",
        "Clinic",
        "Concierge Practice",
        "Hospice",
        "Home Health",
        "Advocacy Group",
        "Independent / Consulting",
        "Other"
    ],
    'drug-developers': [],
    'patients': []
}